<div class="radio-group-title">
  <span> {{ title }}</span>
</div>
<div class="custom-checkbox-group">
  <span class="continuous-line"></span>
  <!-- Single continuous line behind checkboxes -->
  <div *ngFor="let label of labels" class="custom-checkbox-option">
    <input
      type="checkbox"
      [id]="'checkbox-' + label"
      [checked]="selected === label"
      (change)="onSelectionChange(label)"
    />
    <label [for]="'checkbox-' + label">
      <span class="checkbox-label">{{ label }}</span>
      <span class="checkbox-custom" [class.checked]="selected === label"></span>
    </label>
  </div>
</div>
